/**
 * Classify a segment value as easy, medium, or hard based on its normalized position
 * within the min/max range of all segment values for an attendee
 */
export function classifySegmentDifficulty(
  value: number,
  minValue: number,
  maxValue: number
): "easy" | "medium" | "hard" {
  const range = maxValue - minValue;

  if (range === 0) {
    return "medium";
  }

  const normalizedValue = (value - minValue) / range;

  if (normalizedValue < 0.33) {
    return "easy";
  } else if (normalizedValue < 0.67) {
    return "medium";
  } else {
    return "hard";
  }
}
